import './app-search-box.scss';
import Form, { Field, FormApi } from '@atlaskit/form';
import SearchIcon from '@atlaskit/icon/glyph/search';
import Textfield from '@atlaskit/textfield';
import { analytics, AnalyticsTrackAction, AnalyticsTrackSubject } from '@atlassian/temp-analytics';
import * as React from 'react';
import { useHistory } from 'react-router-dom';
import { css } from '@emotion/core';

interface FormData {
  search: string;
}

const appSearchStyles = css({
  width: '240px',
});
// TODO: replace AC callsite like this: <AppSearchBox placeholder = 'Search Advocate Central' />
// TODO: remove default value after updating AC
export const AppSearchBox = ({ placeholder = 'Search Advocate Central' }: { placeholder?: string }) => {
  const history = useHistory();
  return (
    <div className="search-box" data-testid="app-search">
      <Form<FormData>
        onSubmit={(data: FormData, formApi: FormApi<FormData>) => {
          history.push({
            pathname: '/',
            search: `?search=${data.search}`,
          });
          setTimeout(formApi.reset);
          analytics.sendTrackEvent({
            action: AnalyticsTrackAction.SEARCHED,
            actionSubject: AnalyticsTrackSubject.SEARCH_NAVIGATION,
          });
        }}
      >
        {({ formProps }) => (
          <form data-testid="navigation-search-form" {...formProps}>
            <span className="no-label-field">
              <Field name="search" defaultValue="">
                {({ fieldProps }) => (
                  <Textfield
                    {...fieldProps}
                    isCompact
                    role="search"
                    aria-label={placeholder}
                    placeholder={placeholder}
                    elemBeforeInput={
                      <div style={{ paddingLeft: '6px' }}>
                        <SearchIcon label="" size="small" />
                      </div>
                    }
                    css={appSearchStyles}
                  />
                )}
              </Field>
            </span>
            {/* submits the form on enter */}
            <input type="submit" style={{ display: 'none' }} />
          </form>
        )}
      </Form>{' '}
    </div>
  );
};

export default AppSearchBox;
